import React from "react";
import { ToastContext } from "@weezevent/nacre";
import { useTranslation } from "react-i18next";
import { ActionsTypes } from "../constants";

const SUCCESS_TOASTS_TRANSLATIONS = {
	[ActionsTypes.ADD_RIGHTS]:
		"access.attendees.attendeesList.batchActions.addRights.toasts.success",
	[ActionsTypes.REMOVE_RIGHTS]:
		"access.attendees.attendeesList.batchActions.removeRights.toasts.success"
};

const ERROR_TOASTS_TRANSLATIONS = {
	[ActionsTypes.ADD_RIGHTS]:
		"access.attendees.attendeesList.batchActions.addRights.toasts.error",
	[ActionsTypes.REMOVE_RIGHTS]:
		"access.attendees.attendeesList.batchActions.removeRights.toasts.error"
};

export const useAttendeesBatchActionsToasts = () => {
	const toaster = React.useContext(ToastContext);
	const { t } = useTranslation();

	const success = type => {
		toaster.success(t(SUCCESS_TOASTS_TRANSLATIONS[type]));
	};

	const error = type => {
		toaster.error(t(ERROR_TOASTS_TRANSLATIONS[type]));
	};

	return {
		success,
		error
	};
};
